import styled from 'styled-components';
import ColorSF2 from '../../../styles/common/ColorSF2';

export const Main = styled.div`
  height: 100%;
  flex: 1 1 0%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;

export const HeaderContainer = styled.div`
  height: 28px;
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  table-layout: fixed;
`;

export const TableHead = styled.thead`
  background-color: ${ColorSF2.paleBlue};
`;

export const TableBody = styled.tbody`
  background-color: ${ColorSF2.white};
`;

export const TableRow = styled.tr`
  border-bottom: 1px solid ${ColorSF2.mediumGray};
  text-decoration: none;
  cursor: pointer;
  &:hover {
    background-color: ${ColorSF2.skyBlue};
  }
`;

export const ListHeadRow = styled(TableRow)`
  height: 27px;
  &:hover {
    background-color: initial;
  }
`;

export const ScrolledBody = styled.div`
  height: calc(100% - 28px);
  overflow-x: hidden;
  overflow-y: auto;
  margin-bottom: 26px;
`;

export const ThDefault = styled.th`
  overflow: hidden;
  padding-left: 10px;
  text-align: left;
  white-space: nowrap;
  text-overflow: ellipsis;
  position: relative;
  font-size: 14px;
  @media (max-width: 926px) {
    font-size: 11px;
  }
  width: ${props => (props.width && `${props.width}px`) || 'auto'};
`;

export const ThLicenseHead = styled(ThDefault)`
  width: 100px;
  padding-left: 0px;
  text-align: center;
`;

export const TdDefault = styled.td`
  overflow: hidden;
  padding-left: 10px;
  text-align: left;
  white-space: nowrap;
  text-overflow: ellipsis;
  position: relative;
  font-size: 1rem;
  font-weight: normal;
  @media (max-width: 926px) {
    font-size: 12px;
  }
  width: ${props => (props.width && `${props.width}px`) || 'auto'};
`;

export const TdDefaultError = styled(TdDefault)`
  color: ${props => (props.error ? ColorSF2.alertRed : ColorSF2.black)};
`;

export const TdLicenseHead = styled(TdDefaultError)`
  width: 100px;
  padding-left: 0px;
  text-align: center;
`;
